import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useGlobalStore, useBreadcrumb } from '../contexts';

const SideMenu = () => {
  const { store, updateStore } = useGlobalStore();
  const { setBreadcrumb } = useBreadcrumb();
  const location = useLocation();

  const [menuList, setMenuList] = useState([]);
  const [dpMenuList, setDpMenuList] = useState([]);
  const [openMenus, setOpenMenus] = useState({});
  const [heights, setHeights] = useState({});

  const calculateHeight = (menuId, element) => {
    const contentHeight = element?.scrollHeight || 0;
    setHeights(prev => ({
      ...prev,
      [menuId]: contentHeight,
    }));
  };

  const toggleAccordion = menuId => e => {
    e.preventDefault();

    try {
      const accordionBody = e.currentTarget
        ?.closest('.li')
        ?.querySelector('.acco-body');

      if (!accordionBody) {
        return;
      }

      calculateHeight(menuId, accordionBody);

      setOpenMenus(prev => ({
        // ...prev,
        [menuId]: [menuId],
      }));
    } catch (error) {
      return;
    }
  };

  const handleMenuClick = (menuPath, menuHierarchy) => {
    setBreadcrumb(['홈', ...menuHierarchy]);
  };

  useEffect(() => {
    setMenuList(store.menuList);
  }, [store.menuList]);

  useEffect(() => {
    let temp = [];

    if (
      menuList !== undefined &&
      menuList !== null &&
      menuList.length > 0 &&
      store.selectedFirstDepthMenu !== ''
    ) {
      temp = menuList.filter(
        menu => menu.menuId === store.selectedFirstDepthMenu
      )?.[0]?.children;

      if (temp !== undefined && temp !== null && temp.length > 0) {
        if (store.logined === true) {
          temp = temp.filter(menu => {
            if (menu.menuPath && menu.menuPath.length > 0) {
              const menuPathUpperCase = menu.menuPath.toUpperCase();
              return !menuPathUpperCase.includes('LOGIN');
            }
            return true;
          });
        }
      }

      setDpMenuList(temp);
    }
  }, [store.selectedFirstDepthMenu, menuList]);

  useEffect(() => {
    const func = async () => {
      if (menuList?.length > 0) {
        const currentPath = location.pathname;
        const matchingMenu = await findMenuByPath(currentPath);

        if (matchingMenu) {
          let breadCrumbTemp = ['홈'];

          if (
            matchingMenu?.firstDepth === null &&
            matchingMenu?.secondDepth === null &&
            matchingMenu?.thirdDepth === null
          ) {
            return;
          }

          if (
            store.selectedFirstDepthMenu === matchingMenu?.firstDepth?.menuId
          ) {
            setOpenMenus({
              [matchingMenu?.secondDepth?.menuId]: [
                matchingMenu?.secondDepth?.menuId,
              ],
            });
          } else {
            updateStore(
              'selectedFirstDepthMenu',
              matchingMenu?.firstDepth?.menuId
            );
            setOpenMenus({
              [matchingMenu?.secondDepth?.menuId]: [
                matchingMenu?.secondDepth?.menuId,
              ],
            });
          }

          if (matchingMenu.firstDepth !== null) {
            breadCrumbTemp.push(matchingMenu.firstDepth.menuNm);
            setBreadcrumb(breadCrumbTemp);
            if (matchingMenu.secondDepth !== null) {
              breadCrumbTemp.push(matchingMenu.secondDepth.menuNm);
              setBreadcrumb(breadCrumbTemp);
              if (matchingMenu.thirdDepth !== null) {
                breadCrumbTemp.push(matchingMenu.thirdDepth.menuNm);
                setBreadcrumb(breadCrumbTemp);
              }
            }
          }
        }
      }
    };

    func();
  }, [location.pathname, menuList]);

  const findMenuByPath = async pathname => {
    let result = {
      firstDepth: null,
      secondDepth: null,
      thirdDepth: null,
    };

    menuList.forEach(menu => {
      // 1depth 체크
      if (menu.menuPath === pathname) {
        result.firstDepth = menu;
      }

      // 2depth 체크
      if (menu.children?.length > 0) {
        menu.children.forEach(child => {
          if (child.menuPath === pathname) {
            result.firstDepth = menu;
            result.secondDepth = child;
          }

          // 3depth 체크
          if (child.children?.length > 0) {
            child.children.forEach(grandChild => {
              if (grandChild.menuPath === pathname) {
                result.firstDepth = menu;
                result.secondDepth = child;
                result.thirdDepth = grandChild;
              }
            });
          }
        });
      }
    });

    // 3Depth가 존재하면 3Depth를 우선적으로 선택
    if (result.thirdDepth) {
      return result;
    }

    // 2Depth가 존재하면 2Depth를 선택
    if (result.secondDepth) {
      return result;
    }

    // 1Depth만 존재하면 1Depth를 선택
    return result;
  };

  return (
    <>
      {menuList?.length > 0 && store.selectedFirstDepthMenu !== '' && (
        <nav className="left-menu">
          <div className="left-in">
            <h2 className="lnb-tit">
              {
                menuList.filter(
                  menu => menu.menuId === store.selectedFirstDepthMenu
                )[0]?.menuNm
              }
            </h2>
            <ul className="acco-list lnb-list">
              {dpMenuList?.map(dpMenuFirst => (
                <li
                  key={dpMenuFirst.menuId}
                  className={`li ${
                    openMenus[dpMenuFirst.menuId] ? 'active' : ''
                  }`}
                >
                  {dpMenuFirst.children?.length > 0 ? (
                    <>
                      <div className="acco-head">
                        <h3 className="tit">{dpMenuFirst.menuNm}</h3>
                        <button
                          type="button"
                          className={`btn btn-ico acco-btn ${
                            openMenus[dpMenuFirst.menuId] ? 'active' : ''
                          }`}
                          aria-expanded={
                            openMenus[dpMenuFirst.menuId] ? true : false
                          }
                          onClick={toggleAccordion(dpMenuFirst.menuId)}
                        >
                          <span className="sr-only">
                            {openMenus[dpMenuFirst.menuId] ? '접기' : '펼치기'}
                          </span>
                        </button>
                      </div>
                      <div
                        className={`acco-body ${
                          openMenus[dpMenuFirst.menuId] ? 'active' : ''
                        }`}
                        style={{
                          height: openMenus[dpMenuFirst.menuId]
                            ? `${heights[dpMenuFirst.menuId]}px`
                            : '0',
                          visibility: openMenus[dpMenuFirst.menuId]
                            ? 'visible'
                            : 'hidden',
                          transition: 'all 0.3s ease-in-out',
                        }}
                      >
                        <div className="acco-in">
                          <ul className="sub-ul">
                            {dpMenuFirst.children.map(dpMenuSecond => (
                              <li key={dpMenuSecond.menuId}>
                                <Link
                                  to={dpMenuSecond.menuPath}
                                  className="subm"
                                  aria-current="page"
                                  onClick={() => {
                                    handleMenuClick(dpMenuSecond.menuPath, [
                                      menuList.filter(
                                        menu =>
                                          menu.menuId ===
                                          store.selectedFirstDepthMenu
                                      )[0]?.menuNm,
                                      dpMenuFirst.menuNm,
                                      dpMenuSecond.menuNm,
                                    ]);
                                  }}
                                >
                                  {dpMenuSecond.menuNm}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </>
                  ) : (
                    <Link
                      to={dpMenuFirst.menuPath}
                      aria-current="page"
                      onClick={() => {
                        setOpenMenus(prev => ({
                          // ...prev,
                          [dpMenuFirst.menuId]: [dpMenuFirst.menuId],
                        }));
                        handleMenuClick(dpMenuFirst.menuPath, [
                          menuList.filter(
                            menu => menu.menuId === store.selectedFirstDepthMenu
                          )[0]?.menuNm,
                          dpMenuFirst.menuNm,
                        ]);
                      }}
                    >
                      <div className="acco-head">
                        <h3 className="tit">{dpMenuFirst.menuNm}</h3>
                      </div>
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </nav>
      )}
    </>
  );
};

export default SideMenu;
